import DemoNavigation from '~/components/DemoNavigation'
import Hero from '~/components/Hero'
import { P } from '~/components/Typography'

import {
	ArrowsPointingOutIcon,
	BoltIcon,
	HeartIcon,
	LockClosedIcon,
	PaperAirplaneIcon,
	TruckIcon,
} from '@heroicons/react/20/solid'
import FeaturesBlock from '~/components/Features'
import { Link } from '@remix-run/react'
import { sendMessage } from '~/services/notifications/email/email.server'

const blogPosts = [
	{
		id: 1,
		title: 'Bins',
		href: '/bins/',
		imageUrl:
			'/bins.png',

	},
	{
		id: 2,
		title: 'Golf Clubs',
		href: '/golf-clubs/',
		imageUrl:
			'/golf_clubs.png',

	},
	{
		id: 3,
		title: 'Specialty Items',
		href: '/specialty/',
		imageUrl:
			'/specialty_items.png',

	},
	{
		id: 4,
		title: 'Item Rental',
		href: '/specialty/',
		imageUrl:
			'/item_rentals.png',

	},
	{
		id: 5,
		title: 'Vehicle Storage',
		href: '/vehicles/',
		imageUrl:
			'/vehicle_storage.png',

	},
	{
		id: 6,
		title: 'Storage Units',
		href: '/storage/',
		imageUrl:
			'/storage_unit.png',

	},
]

const vehicleStorage = [
	{
		name: 'indoor',
		description: '<a href="/FAQ#vehicles">Stored vehicle care</a>',
		icon: HeartIcon,
	},
	{
		name: 'protected',
		description: 'Protected from the elements',
		icon: LockClosedIcon,
	},
	{
		name: 'electric',
		description: 'Electric vehicles welcome',
		icon: BoltIcon,
	},
]

const storageUnit = [
	{
		name: 'various',
		description: 'Various sizes available in 4-foot increments',
		icon: ArrowsPointingOutIcon,
	},
	{
		name: 'elevator',
		description:
			'Industrial elevator, carts, and dollies to facilitate easy move in and out',
		icon: TruckIcon,
	},
]

const bins = [
	{
		name: 'travel',
		description: 'Travel lighter by leaving your Cabo essentials in Cabo',
		icon: PaperAirplaneIcon,
	},
	{
		name: 'delivery',
		description:
			'Delivery and pick up from your resort',
		icon: TruckIcon,
	},
]

export const action = async ({ request }) => {
	const formData = await request.formData()
	const name = formData.get('first-name')
	const email = formData.get('last-name')
	const message = formData.get('message')

	try {
		await sendMessage({
			to: {
				email: 'teambinz@binzbinzbinz.com',
				name: 'Team Binz',
			},
			subject: 'Contact Form Submission',
			templateId: 'd-bc8967220cb943898f3feca2e03db48d',
			dynamicTemplateData: {
				body: `Name: ${name}\nEmail: ${email}\nMessage: ${message}`
			},
		})
		return { Success: true, error: null }
	} catch (error) {
		console.error('Error sending email:', error)
		return { Success: false, error: error }
	}

}


export default function DemoIndex() {
	return (
		<div className="bg-white">
			{/* Header */}
			<header className="absolute inset-x-0 top-0 z-50">
				<DemoNavigation />
			</header>

			<main className="isolate">
				{/* Hero section */}
				<Hero>

					<h1 className="text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl mt-32 sm:mt-32 lg:mt-0">
						Cabo's <br /> <span className='text-binz-blue'>PREMIER</span> storage solutions
					</h1>
					<P>BINZ BINZ BINZ offers an indoor, climate-controlled, secure storage bodega in Central Cabo San Lucas. BINZ offers a variety of storage solutions to meet your individual needs.</P>

				</Hero>

				{/* Services section */}
				<div className="mx-auto -mt-12 max-w-7xl px-6 sm:mt-0 lg:px-8 xl:-mt-8">
					<div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
						{blogPosts.map((post) => (
							<article
								key={post.id}
								className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
							>
								<img alt="" src={post.imageUrl} className="absolute inset-0 -z-10 h-full w-full object-cover" />
								{/* <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/10" /> */}
								<div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
								<h3 className="mt-8 -mb-4 text-2xl font-bold text-black text-center uppercase">
									<a href={post.href}>
										{post.title}
									</a>
								</h3>
							</article>
						))}
					</div>
				</div>

				<div className='mx-auto m-24 max-w-4xl text-center'>
					<p className='mt-2 text-6xl font-bold tracking-tight text-binz-red'>
						Why store with BINZ?
					</p>
				</div>
				{/* Features section */}
				<FeaturesBlock
					header='Why store with BINZ?'
					features={vehicleStorage}
					image='./car_storage_render.jpg'
					description='Vehicle Storage'
					align='right'
				/>
				<FeaturesBlock
					header='Why store with BINZ?'
					features={storageUnit}
					image='./storage_unit_render.jpg'
					description='Storage Units'
					align='left'
				/>
				<FeaturesBlock
					header='Why store with BINZ?'
					features={bins}
					image='./binz_render.JPG'
					description='Bins, Specialty Items, and Golf Clubs'
					align='right'
				/>
				{/* Team section */}
				<div className="mx-auto mt-32 max-w-7xl px-6 sm:mt-48 lg:px-8">
					<h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
						Need help? Contact us.
					</h2>
					<p className="mt-2 text-lg/8 text-gray-600">
						Before emailing, please read <Link className="text-binz-blue underline" to="/FAQ">FAQ’s</Link> as they will likely answer your questions.
					</p>
					<div className="mt-16 flex flex-col  sm:gap-y-20 lg:flex-row">
						<div className="grid grid-cols-1 sm:grid-cols-2">
							<p className="mt-2 text-lg/8 text-gray-600">
								Please send email inquiries to <a href='mailto:teambinz@binzbinzbinz.com'>teambinz@binzbinzbinz.com</a>
							</p>
						</div>
						{/* <Form action="/" method="POST" className="lg:flex-auto">
								<div>
									<label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
										Name
									</label>
									<div className="mt-2.5">
										<input
											id="first-name"
											name="first-name"
											type="text"
											autoComplete="given-name"
											className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
										/>
									</div>
								</div>
								<div>
									<label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
										Email
									</label>
									<div className="mt-2.5">
										<input
											id="last-name"
											name="last-name"
											type="text"
											autoComplete="family-name"
											className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
										/>
									</div>
								</div>
								<div className="sm:col-span-2">
									<label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
										Message
									</label>
									<div className="mt-2.5">
										<textarea
											id="message"
											name="message"
											rows={4}
											className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
											defaultValue={''}
										/>
									</div>
								</div>
							</div>
							<div className="mt-10">
								<button
									type="submit"
									className="block w-full rounded-md bg-binz-blue px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-binz-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-binz-blue"
								>
									Let’s talk
								</button>
							</div>
							<p className="mt-4 text-sm/6 text-gray-500">
								By submitting this form, I agree to the{' '}
								<Link to="/privacy" className="font-semibold text-binz-blue">
									privacy&nbsp;policy
								</Link>
								.
							</p>
						</Form> */}
						{/* <div className="lg:mt-6 lg:w-80 lg:flex-none">
							<img
								alt=""
								src="https://tailwindui.com/plus/img/logos/workcation-logo-binz-blue.svg"
								className="h-12 w-auto"
							/>
							<figure className="mt-10">
								<blockquote className="text-lg/8 font-semibold text-gray-900">
									<p>
										“We know everything is safe and secure, ready for us to schedule delivery to our resort for the next trip.”
									</p>
								</blockquote>
								<figcaption className="mt-10 flex gap-x-6">

									<div>
										<div className="text-base font-semibold text-gray-900">CandJ</div>
									</div>
								</figcaption>
							</figure>
						</div> */}
					</div>
				</div>
			</main>
		</div>
	)
}
